import { IoHome } from "react-icons/io5";
import SideBarLink from "./SideBarLink";
import { CgReorder } from "react-icons/cg";
import { IoFastFood } from "react-icons/io5";
import { FaUser } from "react-icons/fa";
import { IoLayers } from "react-icons/io5";
import { FaGear } from "react-icons/fa6";
import { GrLanguage } from "react-icons/gr";
import { FaCashRegister } from "react-icons/fa";
import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { useSidebar } from "@/contexts/SidebarContext";
import { useTranslation } from "react-i18next";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { useUserRole } from "@/hooks/useUserRole";
import { AppConfig } from "@/utils/AppConfig";
import { Fragment } from "react/jsx-runtime";
import { PiChefHatFill } from "react-icons/pi";
import { MdDeliveryDining, MdTableBar } from "react-icons/md";

export type SidebarLinks = {
  label: {
    en: string;
    ar: string;
  };
  icon: JSX.Element;
  href: string;
  id: number;
  shouldShow: boolean;
};

function SidebarLinks() {
  const { isShowingIconsOnly } = useSidebar();
  const { t, i18n } = useTranslation();
  const apps = useSelector((state: RootState) => state.apps.AppsData);
  const cashierApp = apps?.find((app) => app.name === "cashier");
  const iconSize = AppConfig.IconSize.sideBar;

  const { hasPermission, isCashier, isChef, isDriver } = useUserRole();


  const sideBarLinks: SidebarLinks[] = [
    {
      label: { en: "dashboard", ar: "لوحة التحكم" },
      icon: <IoHome size={iconSize} />,
      href: "/dashboard",
      id: 1,
      shouldShow: hasPermission("/dashboard"),
    },
    {
      label: { en: "reports", ar: "التقارير" },
      icon: <HiOutlineDocumentReport size={iconSize} />,
      href: "/reports",
      id: 2,
      shouldShow: hasPermission("/reports"),
    },
    {
      label: { en: "cashier", ar: "الكاشير" },
      icon: <FaCashRegister size={iconSize} />,
      href: "/cashier",
      id: 3,
      shouldShow:
        (hasPermission("/cashier") &&
          cashierApp?.available &&
          cashierApp?.installed) ||
        isCashier,
    },
    {
      label: { en: "orders", ar: "الطلبات" },
      icon: <CgReorder size={iconSize} />,
      href: "/orders",
      id: 4,
      shouldShow: hasPermission("/orders"),
    },
    {
      label: { en: "products", ar: "المنتجات" },
      icon: <IoFastFood size={iconSize} />,
      href: "/products",
      id: 5,
      shouldShow: hasPermission("/products"),
    },
    {
      label: { en: "tables", ar: "الطاولات" },
      icon: <MdTableBar size={iconSize} />,
      href: "/tables",
      id: 6,
      shouldShow: hasPermission("/tables"),
    },
    {
      label: { en: "clients", ar: "العملاء" },
      icon: <FaUser size={iconSize} />,
      href: "/clients",
      id: 7,
      shouldShow: hasPermission("/clients"),
    },
    {
      label: { en: "apps", ar: "التطبيقات" },
      icon: <IoLayers size={iconSize} />,
      href: "/apps",
      id: 8,
      shouldShow: hasPermission("/apps"),
    },
    {
      label: { en: "settings", ar: "الإعدادات" },
      icon: <FaGear size={iconSize} />,
      href: "/settings",
      id: 9,
      shouldShow: hasPermission("/settings"),
    },
    // Specific Routes (Optional for some Roles)
    {
      label: { en: "Chef's Orders", ar: "طلبات الشيف" },
      icon: <PiChefHatFill size={iconSize + 2} />,
      href: "/chefs-orders",
      id: 10,
      shouldShow: isChef,
    },
    {
      label: { en: "Driver's Orders", ar: "طلبات عامل التوصيل" },
      icon: <MdDeliveryDining size={iconSize + 2} />,
      href: "/driver-orders",
      id: 11,
      shouldShow: isDriver,
    },
  ];

  return (
    <div>
      <ul
        className={`flex size-full flex-col duration-200 ${isShowingIconsOnly ? "gap-2" : "gap-1"}`}
      >
        {sideBarLinks.map((link, i) => (
          <Fragment key={i}>
            <SideBarLink
              label={link.label}
              href={link.href}
              icon={link.icon}
              id={link.id}
              linksLength={sideBarLinks.length}
              shouldShow={link.shouldShow}
            />
          </Fragment>
        ))}

        <button
          type="button"
          title={isShowingIconsOnly ? (t("Language", "اللغة") as string) : ""}
          onClick={() =>
            i18n.changeLanguage(i18n.language === "en" ? "ar" : "en")
          }
          className="mx-3 mt-2 flex size-full items-center gap-[0.7rem] text-lg font-medium text-[#BAF3FD] lg:hidden"
        >
          <GrLanguage />
          {isShowingIconsOnly ? null : (
            <span>{i18n.language === "ar" ? "English" : "العربية"}</span>
          )}
        </button>
      </ul>
    </div>
  );
}

export default SidebarLinks;
